<template>
  <div class="modal-wrapper">
    <transition name="slide">
      <div
        class="modal"
        v-if="showModal"
        :class="{ 'modal-bg': lang === 'bg', 'modal-en': lang === 'en' }"
      >
        <form @submit.prevent="create()" @keydown.enter.prevent>
          <div class="left">
            <div class="row">
              <!-- DATE -->
              <div class="input">
                <label class="label-with-validation" for="newsDate">
                  <span>*ДАТА</span>
                  <transition name="scale">
                    <span class="kcm kcm-valid" v-if="newsItem.date">R</span>
                  </transition>
                </label>
                <input
                  type="text"
                  id="newsDate"
                  :value="newsItem.date | formatDateDot"
                  placeholder="ДД.ММ.ГГГГ"
                  @change="createNewDateFromString"
                  @keyup="formatDate"
                />
              </div>
              <!-- TYPE -->
              <div class="input">
                <label for="newsType">*ТИП НОВИНА</label>
                <select id="newsType" v-model="newsItem.type">
                  <option value="news">Новина</option>
                  <option value="media">Медиите за нас</option>
                  <option value="gallery">Галерия</option>
                  <option value="news-liferecad">Life Recad Новина</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="newsItem.type === 'media'">
              <div class="input">
                <label for="newsDate">*ИЗТОЧНИК (ИМЕ, ДАТА)</label>
                <input
                  type="text"
                  placeholder="*Източник (име, дата)"
                  id="newsDate"
                  v-model="newsItem.source"
                />
              </div>
              <div class="input">
                <label for="newsDate">*ИЗТОЧНИК (ЛИНК)</label>
                <input
                  type="text"
                  placeholder="*Източник (линк)"
                  id="newsDate"
                  v-model="newsItem.sourceUrl"
                />
              </div>
            </div>
            <!-- TITLE -->
            <div class="input" v-show="lang === 'bg'">
              <label for="newsTitle">*Заглавие (до 80 символа)</label>
              <input
                type="text"
                :placeholder="`*${$t('title')}`"
                id="newsTitle"
                v-model="newsItem.bg.title"
              />
            </div>
            <div class="input" v-show="lang === 'en'">
              <label for="newsTitle">*Заглавие (до 80 символа)</label>
              <input
                type="text"
                :placeholder="`*${$t('title')}`"
                id="newsTitle"
                v-model="newsItem.en.title"
              />
            </div>
            <div class="row">
              <!-- LABEL -->
              <div class="input" v-show="lang === 'bg'">
                <label for="newsLabelBG">*Етикет</label>
                <input
                  type="text"
                  placeholder="*Етикет"
                  id="newsLabelBG"
                  v-model="newsItem.bg.label"
                />
              </div>
              <div class="input" v-show="lang === 'en'">
                <label for="newsLabelEN">*Етикет</label>
                <input
                  type="text"
                  placeholder="*Етикет"
                  id="newsLabelEN"
                  v-model="newsItem.en.label"
                />
              </div>
              <!-- SUBTITLE -->
              <div class="input no-margin-right" v-show="lang === 'bg'">
                <label for="newsSubtitleBG">*Подзаглавие</label>
                <input
                  type="text"
                  placeholder="*Подзаглавие"
                  id="newsSubtitleBG"
                  v-model="newsItem.bg.subtitle"
                />
              </div>
              <div class="input" v-show="lang === 'en'">
                <label for="newsSubtitleEN">*Подзаглавие</label>
                <input
                  type="text"
                  placeholder="*Подзаглавие"
                  id="newsSubtitleEN"
                  v-model="newsItem.en.subtitle"
                />
              </div>
            </div>
            <!-- ROW WITH 3 INPUTS FOR UPLOADING IMAGES -->
            <!-- <div class="row">
              <div class="input">
                <span class="fake-label">{{$t('cover')}}</span>
                <input type="file" id="coverImageInput" @change="onCoverSelected($event, 'cover')" />
                <label for="coverImageInput">
                  <span>Изберете {{ cover || newsItem.cover ? 'ново' : '' }} изображение</span>
                </label>
              </div>
              <div class="input">
                <span class="fake-label">{{$t('gallery')}}</span>
                <input type="file" id="galleryInput" multiple @change="onGallerySelected" />
                <label for="galleryInput">
                  <span>Изберете {{ gallery.length || newsItem.gallery.length ? 'нови' : '' }} изображения</span>
                </label>
              </div>
            </div>-->
            <!-- INPUT REALTIME PREVIEWS -->
            <!-- <p class="images-preview-label" v-if="preview.length">Избрани изображения</p>
            <div class="images-preview" v-if="preview.length">
              <div
                v-for="(p, i) in preview"
                :key="`file-${i}`"
                class="images-preview-item"
                @click="move()"
              >
                <img :src="p.file" alt />
                <span v-if="p.type === 'cover'">{{ $t('cover')}}</span>
                <span v-if="p.type === 'gallery'">{{ $t('gallery')}}</span>
              </div>
            </div>-->
            <div v-if="gallery.length || newsItem.gallery.length">
              <p class="fake-label">Текст на новината преди галерията</p>
            </div>
            <!-- CONTENT 1 -->
            <div class="wrapper-for-quill" v-show="lang === 'bg'">
              <Quill v-model="newsItem.bg.contentOne" />
            </div>
            <div class="wrapper-for-quill" v-show="lang === 'en'">
              <Quill v-model="newsItem.en.contentOne" />
            </div>
            <!-- CONTENT 2 -->
            <div v-show="gallery.length || newsItem.gallery.length">
              <p class="fake-label">Текст на новината след галерията</p>
              <div class="wrapper-for-quill" v-show="lang === 'bg'">
                <Quill v-model="newsItem.bg.contentTwo" />
              </div>
              <div class="wrapper-for-quill" v-show="lang === 'en'">
                <Quill v-model="newsItem.en.contentTwo" />
              </div>
            </div>
          </div>
          <div class="right">
            <span class="fake-label">*СНИМКА ЗА КОРИЦА - 1920X1000 PX</span>
            <div class="row">
              <div class="input-image">
                <input
                  type="file"
                  id="coverImageInput"
                  @change="onCoverSelected($event)"
                />
                <label for="coverImageInput" v-if="!previewCover">
                  <span>+</span>
                </label>
                <img
                  class="image-preview"
                  v-else
                  :src="previewCover.file"
                  alt
                />
                <span
                  class="delete-image"
                  @click="deleteCoverImage()"
                  v-if="previewCover"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.375"
                    height="14"
                    viewBox="0 0 11.375 14"
                  >
                    <path
                      d="M12.25-11.375h-.875V-1.312a1.288,1.288,0,0,1-.1.513,1.317,1.317,0,0,1-.28.417,1.317,1.317,0,0,1-.417.28,1.288,1.288,0,0,1-.513.1h-7A1.288,1.288,0,0,1,2.55-.1a1.317,1.317,0,0,1-.417-.28A1.317,1.317,0,0,1,1.853-.8a1.288,1.288,0,0,1-.1-.513V-11.375H.875v-.875h3.5v-.875a.848.848,0,0,1,.068-.342.889.889,0,0,1,.188-.277.889.889,0,0,1,.277-.188A.848.848,0,0,1,5.25-14H7.875a.848.848,0,0,1,.342.068.889.889,0,0,1,.277.188.889.889,0,0,1,.188.277.848.848,0,0,1,.068.342v.875h3.5Zm-7-.875H7.875v-.875H5.25Zm5.25.875H2.625V-1.312A.42.42,0,0,0,2.755-1a.42.42,0,0,0,.308.13h7A.42.42,0,0,0,10.37-1a.42.42,0,0,0,.13-.308ZM5.25-2.625H4.375v-7H5.25Zm1.75,0H6.125v-7H7Zm1.75,0H7.875v-7H8.75Z"
                      transform="translate(-0.875 14)"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <!-- TODO: REMOVE THE BRs -->
            <br />
            <br />
            <!-- TODO: REMOVE THE BRs -->
            <span class="fake-label"
              >СНИМКИ ЗА ГАЛЕРИЯ - 1920X1000 PX (ДО 12 БРОЯ)</span
            >
            <div class="row row-gallery">
              <div
                class="input-image"
                v-for="(p, i) in previewGallery"
                :key="`previewGallery-${i}`"
              >
                <img class="image-preview" :src="p.file" alt />
                <span class="delete-image" @click="deleteGalleryImage(i, p)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.375"
                    height="14"
                    viewBox="0 0 11.375 14"
                  >
                    <path
                      d="M12.25-11.375h-.875V-1.312a1.288,1.288,0,0,1-.1.513,1.317,1.317,0,0,1-.28.417,1.317,1.317,0,0,1-.417.28,1.288,1.288,0,0,1-.513.1h-7A1.288,1.288,0,0,1,2.55-.1a1.317,1.317,0,0,1-.417-.28A1.317,1.317,0,0,1,1.853-.8a1.288,1.288,0,0,1-.1-.513V-11.375H.875v-.875h3.5v-.875a.848.848,0,0,1,.068-.342.889.889,0,0,1,.188-.277.889.889,0,0,1,.277-.188A.848.848,0,0,1,5.25-14H7.875a.848.848,0,0,1,.342.068.889.889,0,0,1,.277.188.889.889,0,0,1,.188.277.848.848,0,0,1,.068.342v.875h3.5Zm-7-.875H7.875v-.875H5.25Zm5.25.875H2.625V-1.312A.42.42,0,0,0,2.755-1a.42.42,0,0,0,.308.13h7A.42.42,0,0,0,10.37-1a.42.42,0,0,0,.13-.308ZM5.25-2.625H4.375v-7H5.25Zm1.75,0H6.125v-7H7Zm1.75,0H7.875v-7H8.75Z"
                      transform="translate(-0.875 14)"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </div>
              <div class="input-image" v-if="previewGallery.length < 12">
                <input
                  type="file"
                  id="galleryImageInput"
                  @change="onGallerySelected($event)"
                />
                <label for="galleryImageInput">
                  <span>+</span>
                </label>
              </div>
            </div>
          </div>
        </form>
        <div class="row row-last">
          <div class="languages">
            <p>ЕЗИЦИ</p>
            <span
              class="lang lang-bg"
              :class="{ 'lang-active': lang === 'bg' }"
              @click="lang = 'bg'"
              >BG</span
            >
            <span
              class="lang lang-en"
              :class="{ 'lang-active': lang === 'en' }"
              @click="lang = 'en'"
              >EN</span
            >
            <div v-if="id" class="buttons">
              <button class="button-delete" @click.prevent="deleteNews()">
                <span>Изтриване</span>
              </button>
            </div>
          </div>
          <div class="buttons">
            <button class="button-close" @click.prevent="close()">
              <span>Отказ</span>
            </button>
            <button
              class="button-submit"
              :disabled="loading"
              @click.prevent="create()"
            >
              <span v-if="id">{{ $t("edit") }}</span>
              <span v-else>{{ $t("create") }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <div
      class="progress"
      :class="{ 'progress-active': loading }"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>

<script>
import Quill from "../shared/Quill";
export default {
  components: {
    Quill,
  },
  props: ["id"],
  data() {
    return {
      showModal: false,
      loading: false,
      progress: 0,
      cover: null,
      gallery: [],
      previewCover: null,
      previewGallery: [],
      lang: "bg",
      imagesForDeleting: [],
      newsItem: {
        date: "",
        type: "news",
        gallery: [],
        cover: "",
        bg: {
          title: "",
          subtitle: "",
          label: "",
          contentOne: "",
          contentTwo: "",
        },
        en: {
          title: "",
          subtitle: "",
          label: "",
          contentOne: "",
          contentTwo: "",
        },
      },
    };
  },
  methods: {
    formatDate(event) {
      event.target.value = event.target.value
        .replace(/[^0-9.]/g, "")
        .substr(0, 10);
    },
    createNewDateFromString(event) {
      const t = event.target.value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (t !== null) {
        const d = +t[1];
        const m = +t[2];
        const y = +t[3];
        const date = new Date(y, m - 1, d);
        if (date.getFullYear() === y && date.getMonth() === m - 1) {
          // return date;
          this.newsItem.date = date;
        } else {
          this.newsItem.date = null;
        }
      } else {
        this.newsItem.date = null;
      }
    },
    onCoverSelected(e) {
      if (this.validateImage(e.target.files[0])) {
        this.cover = e.target.files[0];
        this.makePreview("cover", this.cover, false);
      }
    },
    move() {
      this.previewGallery = [];
      const item = this.newsItem.gallery.splice(this.gallery.length - 1);
      this.newsItem.gallery.unshift(item);
      this.getPreviews();
    },
    deleteCoverImage() {
      if (this.newsItem.cover) {
        this.imagesForDeleting.push(this.newsItem.cover);
      }
      this.newsItem.cover = null;
      this.cover = null;
      this.previewCover = null;
    },
    onGallerySelected(e) {
      if (this.validateImage(e.target.files[0])) {
        this.gallery.push(e.target.files[0]);
        this.makePreview("gallery", e.target.files[0], false);
      }
    },
    deleteGalleryImage(i, img) {
      // if image is not uploaded
      if (img.name) {
        const index = this.gallery.findIndex((item) => item.name === img.name);
        this.gallery.splice(index, 1);
      } else {
        const image = img.file.split("/").pop();

        const newsItemIndex = this.newsItem.gallery.indexOf(image);
        this.newsItem.gallery.splice(newsItemIndex, 1);

        this.imagesForDeleting.push(image);
      }
      this.previewGallery.splice(i, 1);
    },
    validateImage(file) {
      if (file) {
        if (!file.name.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/)) {
          this.$snotify.error(
            "Можете да качвате само изображения във формат - .jpg, .png или .gif"
          );
          return false;
        }
        if (!(file.size < 1 * 1024 * 1024)) {
          // TODO: SEND ERROR TO UI
          this.$snotify.error(
            "Можете да качвате само изображения с големина до 1 MB"
          );
          return false;
        }
        return true;
      }
    },
    cleanPreview(type) {
      this.previewGallery = this.previewGallery.filter((f) => {
        return f.type !== type;
      });
    },
    getPreviews() {
      if (this.newsItem.cover) {
        this.makePreview("cover", this.newsItem.cover, true);
      }
      if (this.newsItem.gallery) {
        for (let i = 0; i < this.newsItem.gallery.length; i++) {
          this.makePreview("gallery", this.newsItem.gallery[i], true);
        }
      }
    },
    makePreview(type, file, uploaded) {
      let f = null;

      if (uploaded) {
        f = `${process.env.VUE_APP_UPLOADS_URI}/${file}`;
      } else {
        f = URL.createObjectURL(file);
      }
      if (type === "cover") {
        this.previewCover = { type: type, file: f };
      } else {
        this.previewGallery.push({
          type: type,
          file: f,
          name: file.name,
        });
      }
    },
    getNews() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/news/${this.id}`)
        .then((result) => {
          this.newsItem = result.data;
          this.getPreviews();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    create() {
      if (this.isValid()) {
        this.loading = true;
        this.progress = 0;
        // let imagesForDeleting = [];

        const fd = new FormData();
        fd.append("data", JSON.stringify(this.newsItem));

        if (this.cover) {
          fd.append("cover", this.cover, this.cover.name);
        }

        if (this.gallery.length) {
          for (let i = 0; i < this.gallery.length; i++) {
            fd.append("gallery", this.gallery[i]);
          }
          // if (this.id && this.newsItem.gallery) {
          //   for (let i = 0; i < this.newsItem.gallery.length; i++) {
          //     imagesForDeleting.push(this.newsItem.gallery[i]);
          //   }
          // }
        }

        let url = `${process.env.VUE_APP_BASE_URI}/news`;
        let type = "post";

        if (this.id) {
          url += `/${this.id}`;
          type = "put";

          if (this.imagesForDeleting.length) {
            fd.append("delete", JSON.stringify(this.imagesForDeleting));
          }
        }

        this.$http[type](url, fd, {
          onUploadProgress: (ue) => {
            this.progress = Math.round((ue.loaded / ue.total) * 100);
          },
        })
          .then(() => {
            if (this.id) {
              this.$snotify.success("Новината е редактирана успешно!");
            } else {
              this.$snotify.success("Успешно създадена новина!");
            }
            setTimeout(() => {
              this.close(true);
            }, 300);
          })
          .catch((err) => {
            console.log(err);
            this.$snotify.error("Нещо се обърка, моля опитайте отново.");
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.progress = 0;
            }, 1000);
          });
      }
    },
    isValid() {
      if (!this.newsItem.date) {
        this.$snotify.error("Новината трябва да има дата.");
        return false;
      }
      if (this.newsItem.type === "media") {
        if (!this.newsItem.source) {
          this.$snotify.error("Новината трябва да има източник.");
          return false;
        }
        if (!this.newsItem.sourceUrl) {
          this.$snotify.error("Новината трябва да има линк към източник.");
          return false;
        }
      }
      if (!this.newsItem["bg"].title) {
        this.$snotify.error(
          "Новината трябва да има заглавие на български език."
        );
        return false;
      }
      if (!this.newsItem["bg"].label) {
        this.$snotify.error("Новината трябва да има етикет на български език.");
        return false;
      }
      if (!this.newsItem["bg"].subtitle) {
        this.$snotify.error(
          "Новината трябва да има подзаглавие на български език."
        );
        return false;
      }

      if (this.newsItem["en"].title) {
        if (!this.newsItem["en"].label) {
          this.$snotify.error(
            "Въвеждането на заглавие на английски изисква и въвеждане на етикет."
          );
          return false;
        }
        if (!this.newsItem["en"].subtitle) {
          this.$snotify.error(
            "Въвеждането на заглавие на английски изисква и въвеждане на подзаглавие"
          );
          return false;
        }
      }

      if (!this.newsItem.cover && !this.cover) {
        this.$snotify.error("Новината трябва да има корица.");
        return false;
      }
      // if(this.newsItem.type === 'gallery') {
      //   if (!this.newsItem.gallery.length && !this.newsItem.gallery.length) {
      //     this.$snotify.error("Новината трябва да има поне едно изображение в галерията.");
      //     return false;
      //   }
      // }
      return true;
    },
    deleteNews() {
      if (confirm("Сигурни ли сте, че искате да изтриете новината?")) {
        let url = `${process.env.VUE_APP_BASE_URI}/news/${this.id}`;
        this.$http
          .delete(url, {
            onUploadProgress: (ue) => {
              this.progress = Math.round((ue.loaded / ue.total) * 100);
            },
          })
          .then(() => {
            this.$snotify.success("Новината е изтрита успешно!");
            setTimeout(() => {
              this.close(true);
            }, 300);
          })
          .catch((err) => {
            console.log(err);
            this.$snotify.error("Нещо се обърка, моля опитайте отново.");
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.progress = 0;
            }, 1000);
          });
      }
    },
    close(refresh) {
      this.$parent.$emit("close-news-modal", refresh);
    },
  },
  mounted() {
    if (this.id) {
      this.getNews();
    } else {
      this.newsItem.type = this.$route.query.type;
    }
    setTimeout(() => {
      this.showModal = true;
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  min-width: 1000px;
}
.modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
  overflow: initial;
  padding: 0;
  @include transition(background-color 0.3s);
  width: 90%;
}
.modal-bg {
  background-color: #f9fcf9;
}
.modal-en {
  background-color: #f9f5f7;
}
form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  margin: 0 auto;
  max-height: calc(100vh - 40px);
  overflow: auto;
  padding: 20px 20px 0;
  width: 100%;
  .left {
    padding-right: 20px;
    width: 60%;
  }
  .right {
    border-left: 1px solid #d2e2f5;
    padding-left: 20px;
    width: 40%;
    .fake-label {
      display: block;
    }
  }
}
.row .input {
  margin-right: 10px;
}
.row .input:last-child {
  margin-right: 0;
}
.row .no-margin-right {
  margin-right: 0;
}
.row .label-with-validation {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .kcm {
    color: #000;
  }
  .kcm-valid {
    color: green;
  }
}
.row-gallery {
  flex-wrap: wrap;
}
.progress {
  background-color: $accentColor;
  display: block;
  height: 5px;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 2;
  @include transition(width 0.3s);
}
.progress-active {
  opacity: 1;
}
// PREVIEW
.images-preview-label {
  font-size: 10px;
  font-weight: 700;
  margin-bottom: 4px;
  text-transform: uppercase;
}
.images-preview {
  background-color: #fff;
  border: 1px solid $bgColor3;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.images-preview-item {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  padding: 5px;
  width: 16.66%;
}
.images-preview-item span {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  opacity: 0.5;
  margin-top: 2px;
}
.images-preview-item img {
  background-color: $bgColor4;
  border: 1px solid $bgColor3;
  height: 70px;
  -o-object-fit: contain;
  object-fit: contain;
  width: 100%;
}
.row-last {
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  .languages {
    align-items: center;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    display: flex;
    p {
      color: #6f6f6f;
      font-size: 13px;
      line-height: 13px;
      margin-right: 10px;
    }
    .lang {
      @extend %flex-center;
      color: #3d3d3d;
      cursor: pointer;
      font-size: 13px;
      height: 40px;
      @include transition(all 0.2s $mainCubic);
      width: 40px;
    }
    .lang-active.lang-bg,
    .lang:hover.lang-bg {
      background-color: #009105;
      color: #fff;
    }
    .lang-active.lang-en,
    .lang:hover.lang-en {
      background-color: #cf142b;
      color: #fff;
    }
  }
  .buttons {
    button {
      padding: 0 30px;
      span {
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
      }
    }
    .button-close {
      background-color: #dbdbdb;
      color: #000;
    }
    .button-delete {
      background-color: $accentColor;
      margin-left: 10px;
      color: #fff;
    }
    .button-submit {
      margin-left: 10px;
      background-color: $mainColor;
    }
  }
}
.wrapper-for-quill {
  background-color: #f7f7f7;
}
</style>
